"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRibbonRounding = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-radius: ", ";\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * @param {('left'|'right')} direction The side to receive semi-circular rounding
 * @return {Function} A styled-components mixin
 */
var setRibbonRounding = function setRibbonRounding() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
  return (0, _styledComponents.css)(_templateObject(), direction === 'right' ? '20px 6px 6px 20px' : '6px 20px 20px 6px', direction === 'right' ? '0 6px 0 10px' : '0 10px 0 6px');
};

exports.setRibbonRounding = setRibbonRounding;